import { QueryClient } from '@tanstack/react-query';
import { create } from 'zustand';

import { createQueryClient } from './query-client';

type QueryClientStore = {
	queryClient: QueryClient;
	setQueryClient: (queryClient: QueryClient) => void;
};

export const useQueryClientStore = create<QueryClientStore>()((set) => ({
	queryClient: createQueryClient(),
	setQueryClient: (queryClient) => set({ queryClient }),
}));

export const getQueryClient = () => {
	return new Promise<QueryClient>((resolve) => {
		const client = useQueryClientStore.getState().queryClient;

		if (client) {
			return resolve(client);
		}

		const unsubscribe = useQueryClientStore.subscribe((state) => {
			if (state.queryClient) {
				unsubscribe();
				resolve(state.queryClient);
			}
		});
	});
};
